import * as Styled from './Icon.styled';
import { IconConfig } from './Icon.config';
import { type IconProps } from './Icon.typed';

export const Icon = (props: IconProps) => {
  const { name, size = 'm', color, ...rest } = props;
  return (
    <Styled.Wrapper {...rest} color={color} size={size}>
      {IconConfig[name]}
    </Styled.Wrapper>
  );
};

export default Icon;
